import { conceptType } from '../variables/Enums';
import axios from './index';

export const searchConcept = (conceptId, term, type = conceptType.events) => {
    return axios.get(`api/v1/snowstorm/${type}/SearchConcept/${conceptId}/${term}`);
};

export const searchConceptByExpression = (expression, term, type = conceptType.events) => {
    return axios.get(`api/v1/snowstorm/${type}/SearchByExpression/${expression}/${term}`);
};

// branch: la rama del catálogo del campo ({ conceptId } o { expression }), para que el backend descarte
// frecuentes SNOMED de otro dominio (ej. un procedimiento frecuente en el campo de EA).
export const searchFrequentConcepts = (type = conceptType.events, term, take, branch = {}) => {
    const query = new URLSearchParams({ conceptType: type, term, take });
    if (branch.conceptId) query.append('branchConceptId', branch.conceptId);
    else if (branch.expression) query.append('branchExpression', branch.expression);

    return axios.get(`api/v1/concept/frequent?${query.toString()}`);
};

export const searchCustomConcepts = (type = conceptType.events, term, take) => {
    return axios.get(`api/v1/concept/custom?conceptType=${type}&term=${encodeURIComponent(term)}&take=${take}`);
};

export const createCustomConcept = (type = conceptType.events, term, confirmDespiteSimilar = false) => {
    return axios.post(`api/v1/concept/custom`, { conceptType: type, term, confirmDespiteSimilar });
};

export const getConceptUsages = (term, pageSize, pageIndex) => {
    const query = new URLSearchParams();
    if (term) query.append('term', term);
    query.append('pageSize', pageSize);
    query.append('pageIndex', pageIndex);

    return axios.get(`api/v1/concept/usages?${query.toString()}`);
};

export const setConceptUsage = (conceptId, usageCount) => {
    return axios.put(`api/v1/concept/${conceptId}/usage`, { usageCount });
};